import styled from 'styled-components'
import { ModalButton } from '../styles'

const AssignButton = styled(ModalButton)`
  padding: 0 8px;
  font-size: 1rem;
`

export { AssignButton }
